import { Constants } from 'src/app/models/constants';
export const environment: any = {
  production: false,
  node: Constants.TENANT_ID_DO,
  version: '2026-11-04 12:31:48 - 1ad3405',
  oldFrontUrl: 'https://gestion-do.develop-redremax.com',
  newFrontUrl: 'https://gestion-do-v2.develop-redremax.com',
  apiEndpoint: 'https://api-ar.develop-redremax.com/gestion-be/do/proxy',
  authApiBaseUrl: 'https://api-do.develop-redremax.com/auth',
  afipEndpoint: '',
  jenkinsEndpoint: '',
  googleAPIKey: 'AIzaSyC3X_ar4N9z68tmVAks_guaUOoqmBztTmQ',
  currencyCookieDomain: 'develop-redremax.com',
  monitorKey: 'Ax684fTd1',

  routeAuthorization: {
    // Propiedades
    ranking: [
      Constants.USER_ROLES_STAFF,
      Constants.USER_ROLES_BROKER,
      Constants.USER_ROLES_REGIONAL,
      Constants.USER_ROLES_AGENT,
    ],
    panel: [
      Constants.USER_ROLES_STAFF,
      Constants.USER_ROLES_BROKER,
      Constants.USER_ROLES_REGIONAL,
      Constants.USER_ROLES_AGENT,
    ],
    qrcomps: [
      Constants.USER_ROLES_STAFF,
      Constants.USER_ROLES_BROKER,
      Constants.USER_ROLES_REGIONAL,
      Constants.USER_ROLES_AGENT,
    ],
    dashboard: [
      Constants.USER_ROLES_STAFF,
      Constants.USER_ROLES_BROKER,
      Constants.USER_ROLES_REGIONAL,
      Constants.USER_ROLES_AGENT,
    ],
    downloads: [
      Constants.USER_ROLES_STAFF,
      Constants.USER_ROLES_BROKER,
      Constants.USER_ROLES_REGIONAL,
      Constants.USER_ROLES_AGENT,
    ],
  },
  loginCountries: Constants.LOGIN_COUNTRIES_DEV,
};
